import React from 'react';

import { useElementVisibility } from '~/src/common/hooks/useElementVisibility';
import I18n from '~/src/common/services/I18n';
import { SubCategory } from '~/src/common/typings/category';
import { sanitize } from '~/src/common/utils/text';
import { useGetCategory } from '~/src/queries/api-ecom/generated/api-ecom';
import HomeSubcategorySwiper from '~/src/screens/Home/HomeSubcategory/HomeSubcategorySwiper';

import * as S from './layout';

interface Props {
  subcategory: SubCategory;
  subcategoriesCount: number;
  position: number;
}

const HomeCategory = ({ subcategory, position, subcategoriesCount }: Props) => {
  const [ref, visible] = useElementVisibility();
  const { id, title, slug, itemCount } = subcategory;
  const enabled = visible && itemCount > 0;

  // Chargement de la catégorie et extraction des infos
  const { data, refetch, isLoading } = useGetCategory(slug, {
    query: { enabled },
  });

  //Les différents états possible de l'affichage
  const isEmpty = subcategory.itemCount === 0;

  const { items } = data ?? {};

  const description = sanitize(subcategory.description ?? '');

  return (
    <div ref={ref} aria-hidden={isEmpty} data-observed={id}>
      <S.TitleContainer>
        <S.Title>{title}</S.Title>
        {description ? <S.Description>{description}</S.Description> : null}
      </S.TitleContainer>
      {isEmpty ? (
        <S.EmptyText>{I18n.t('products-grid.empty')}</S.EmptyText>
      ) : (
        <HomeSubcategorySwiper
          id={id}
          position={position}
          products={items}
          productsCount={itemCount}
          subcategoriesCount={subcategoriesCount}
          name={title}
          isLoading={isLoading}
          onRefresh={refetch}
        />
      )}
    </div>
  );
};

export default React.memo(HomeCategory);
